import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=4a65f6b7&scoped=true"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=4a65f6b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a65f6b7",
  null
  
)

export default component.exports